import Cookies from './Cookies';
export default Cookies;



//////////////////
// WEBPACK FOOTER
// ./node_modules/universal-cookie/es6/index.js
// module id = 660
// module chunks = 0